import summaryIcon from '../assets/images/icons/summary.png';
import categoryIcon from '../assets/images/icons/category.png';
import poapIcon from '../assets/images/icons/poap.png';
import tldByYearIcon from '../assets/images/icons/tldbyyear.png';
import planningStrategyIcon from '../assets/images/icons/planningstrategy.png';
import technicalScopeIcon from '../assets/images/icons/technicalscope.png';
import engineeringScopeIcon from '../assets/images/icons/engineeringscope.png';
import sheqIcon from '../assets/images/icons/summary.png'; // Assuming it's the same
import logisticsIcon from '../assets/images/icons/logistics.png';
import procurementIcon from '../assets/images/icons/procurement.png';
import kpisIcon from '../assets/images/icons/kpis.png';
import risksIcon from '../assets/images/icons/riskoverview.png';
import dataQualityIcon from '../assets/images/icons/dataquality.png';
import innoflexIcon from '../assets/images/icons/innoflexoverview.png';

const HomeData = [
  {
    name: 'Summary',
    icons: summaryIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/4747a6f17c845d306492?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Category View',
    icons: categoryIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/da44b44b0ba0a4844f59?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Plan on a page',
    icons: poapIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/301f69d8adc6bdce513e?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'TLD by Year / Quarter',
    icons: tldByYearIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/edf1208612a4f6edd4a8?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Planning Strategy',
    icons: planningStrategyIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/f6f58fb6eca044cc9200?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Technical Scope',
    icons: technicalScopeIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/e5c94de43a07880d1267?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Engineering Scope',
    icons: engineeringScopeIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/2cac7614b7e3560f1c42?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'SHEQ / Sustainability',
    icons: sheqIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/813e03b39a64bf4e5c89?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Logistics',
    icons: logisticsIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/019dbf5e353ce7b6d04d?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Procurement',
    icons: procurementIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/1f8cff57ea860acaf44c?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'KPIs',
    icons: kpisIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/6290db641cda2473e17c?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Risks Overview',
    icons: risksIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/05c63fe46487e5740754?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Data Quality',
    icons: dataQualityIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/6e14a85f99b4604a2f12?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  },
  {
    name: 'Innoflex Overview',
    icons: innoflexIcon,
    link: 'https://app.powerbi.com/groups/me/apps/3cc60898-d72e-4286-b0e2-63d051bf50e8/reports/d524dd9c-5560-4666-842b-09f0896a55db/897cd604468dfcf85884?ctid=f66fae02-5d36-495b-bfe0-78a6ff9f8e6e&experience=power-bi'
  }
];

export default HomeData;
